import { render, staticRenderFns } from "./LetterOfAuthorization.vue?vue&type=template&id=3f069b07&scoped=true&"
import script from "./LetterOfAuthorization.vue?vue&type=script&lang=js&"
export * from "./LetterOfAuthorization.vue?vue&type=script&lang=js&"
import style0 from "./LetterOfAuthorization.vue?vue&type=style&index=0&id=3f069b07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f069b07",
  null
  
)

export default component.exports